import { getUcatModuleDurationMinutes } from './getUcatModuleDurationMinutes';
import { getBmatSectionDurationMinutes } from './classifyBmatPaperSection';

function positiveMinutes(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Minutes for Pearson Retake / post_exam → m0_items restart.
 * Topic drills keep live payload minutes (UCAT 40 wins). Mocks still use
 * getUcatModuleDurationMinutes GENERIC_MINUTES rejection.
 */
export function getTopicDrillRestartMinutes({
  isTopicDrill = false,
  isUcatExam = false,
  isTaraBmatSitting = false,
  pearsonModules = [],
  tmuaP1TimerDuration,
} = {}) {
  if (isTopicDrill) {
    const slot = positiveMinutes(pearsonModules?.[0]?.durationMinutes);
    if (slot != null) return slot;
    const p1 = positiveMinutes(tmuaP1TimerDuration);
    if (p1 != null) return p1;
    return isUcatExam
      ? getUcatModuleDurationMinutes(pearsonModules?.[0] || { moduleKey: 'verbal_reasoning' })
      : 40;
  }
  if (isUcatExam) {
    return getUcatModuleDurationMinutes(pearsonModules?.[0] || { moduleKey: 'verbal_reasoning' });
  }
  if (isTaraBmatSitting) {
    return getBmatSectionDurationMinutes(pearsonModules?.[0]?.moduleKey);
  }
  return 40;
}
